import { render } from "./IconAlertSimple.vue?vue&type=template&id=05b579dc&lang=html"
import script from "./IconAlertSimple.vue?vue&type=script&lang=js"
export * from "./IconAlertSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__